import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Button from '../fields/Button';
import { Context as CloseContext } from './Close';
import styles from './DialogButtons.less';

const cxb = cx.bind(styles);

DialogButtons.propTypes = {
  /** Override the default and let buttons size to their content. */
  fit: PropTypes.bool,
};

/**
 * **Access:**
 * ```js
 * import { DialogButton } from '@iss/client-react-components'
 * ```
 *
 * Provides a button area where buttons are placed right to left
 */
export default function DialogButtons({ children, className, fit, ...props }) {
  return (
    <CloseContext.Consumer>
      {(close) => (
        <div {...props} className={cxb('root', className, { fit })}>
          {React.Children.map(children, (x) =>
            shouldAddCloseHandler(x) ? React.cloneElement(x, { onClick: close }) : x
          )}
        </div>
      )}
    </CloseContext.Consumer>
  );
}

function shouldAddCloseHandler(el) {
  const { props = {}, type } = el || {};
  // ignore falsy elements, and buttons with click handlers.
  if (!el || props.onClick != null) return false;

  const isButtonComponent = type === Button;
  const isButton = isButtonComponent || props.as === 'button' || type === 'button';

  // ignore primary | submit buttons (the default for `type` for HTMLButton is "submit")
  if (isButton && (props.type === 'submit' || (!isButtonComponent && props.type == null))) return false;

  return true;
}
